var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
/**
 * 中间件管理器，用于收集中间件
 */
var InterceptorManager = /** @class */function () {
  function InterceptorManager() {
    var _this = this;
    this._handles = [];
    /**
     * 添加中间件
     * @param resolveHandle
     * @param rejectHandle
     */
    this.use = function (resolveHandle, rejectHandle) {
      _this._handles.push({
        resolveHandle: resolveHandle,
        rejectHandle: rejectHandle
      });
    };
    /**
     * 获取深copy的中间件
     */
    this.get = function () {
      return _this._handles.map(function (item) {
        return __assign({}, item);
      });
    };
  }
  return InterceptorManager;
}();
export default InterceptorManager;